module.exports = "/assets/xvyY_s4wZU.png";